import { DB } from './index';
import time from '../time';

type ConfigDao = {
    key: string; // key 主键
    val: string; // 值
    utime: number; // 更新时间
    ctime: number; // 创建时间
};

export async function config_get_by_val(
    db: DB,
    val: string,
): Promise<{
    error?: any;
    data?: ConfigDao[];
}> {
    const r = await db.Query(
        `select key, val, utime, ctime from t_config where val = ?`,
        [val],
    );
    if (r.error) {
        return { error: r.error };
    }
    if (r.data && r.data.length > 0) {
        return { data: r.data as ConfigDao[] };
    }
    return {};
}

// 获取config
export async function config_get(
    db: DB,
    key: string,
): Promise<{
    error?: any;
    data?: ConfigDao;
}> {
    const r = await db.Query(
        `select key, val, utime, ctime from t_config where key = ?`,
        [key],
    );

    if (r.error) {
        return { error: r.error };
    }

    if (r.data && r.data.length > 0) {
        return {
            data: {
                key: r.data[0].key,
                val: r.data[0].val,
                utime: r.data[0].utime,
                ctime: r.data[0].ctime,
            },
        };
    }

    return {};
}

// 设置config
export async function config_set(
    db: DB,
    key: string,
    val: string,
): Promise<{
    error?: any;
}> {
    const utime = time.toUnixMillSecond(time.now());
    const ctime = utime;
    // const r = await db.Execute(
    //     'INSERT INTO t_config (key, val, utime, ctime)' +
    //         `VALUES ('${key}', '${val}', ${utime}, ${ctime}) ` +
    //         'ON CONFLICT(key) ' +
    //         `DO UPDATE SET val = '${val}', utime = ${utime}`,
    //     [],
    // );

    const sql = `
  INSERT INTO t_config (key, val, utime, ctime)
  VALUES (?, ?, ?, ?)
  ON CONFLICT(key)
  DO UPDATE SET val = ?, utime = ?
`;

    const params = [key, val, utime, ctime, val, utime];

    const r = await db.Execute(sql, params);

    if (r.error) {
        return { error: r.error };
    }
    return {};
}
